<div class="terms-wrapper">
  <div class="terms-container">
    <h1>Terms and Conditions</h1>
    <p class="sub-text"><strong>Platform:</strong> Coinwush</p>
    <p class="sub-text"><strong>Last Updated:</strong> {{ lastUpdated }}</p>

    <p>
      This document is a computer-generated electronic record pursuant to Rule 3
      of the Information Technology (Intermediary Guidelines and Digital Media
      Ethics Code) Rules, 2021 (as amended from time to time), and does not
      require any physical or digital signature.
    </p>

    <!-- <p>
      Coinwush is operated by
      <strong>Questalious Private Limited (CIN: U63119UP2025PTC222413)</strong>,
      having its registered office at 155/101, Gali No. 7, Hari Nagar,
      Kankerkhera, Meerut – 250001, Uttar Pradesh, India. Questalious Private
      Limited (Corporate Identification Number: U63119UP2025PTC222413), a
      company incorporated under the Companies Act, 2013, having its registered
      office at 155/101, Gali No. 7, Hari Nagar, Kankerkhera, Meerut – 250001,
      Uttar Pradesh, India (hereinafter referred to as "Coinwush", "Company",
      "we", "us", or "our"), operates an online derivatives trading platform
      accessible via the website https://coinwush.com/ and associated mobile
      applications available on the Google Play Store and the Apple App Store
      (collectively referred to as the "Platform").
    </p> -->
    <p>
      These Terms and Conditions (hereinafter referred to as "Terms") govern
      your access to and use of the Platform and all services offered thereon.
      By accessing, downloading, registering for, or using the Platform and/or
      Services in any manner, or by clicking "I Agree", you acknowledge that you
      have read, understood, and agree to be bound by these Terms in their
      entirety, along with our Privacy Policy and any other applicable policies
      published on the Platform from time to time (collectively, the
      "Policies").
    </p>

    <p>
      If you do not agree with any part of this Privacy Policy, you must
      immediately discontinue access to and use of the Platform and Services.
    </p>

    <!-- Risk Disclaimer -->
    <div class="highlight-box">
      <h3>Important Risk Disclaimer</h3>
      <p>
        CRYPTO DERIVATIVE PRODUCTS ARE UNREGULATED AND CAN BE HIGHLY RISKY.
        THERE MAY BE NO REGULATORY RECOURSE FOR ANY LOSS FROM SUCH TRANSACTIONS.
        TRADING IN DERIVATIVES LINKED TO VIRTUAL DIGITAL ASSETS INVOLVES A HIGH
        DEGREE OF RISK AND MAY NOT BE SUITABLE FOR ALL INVESTORS. THE VALUE OF
        UNDERLYING DIGITAL ASSETS IS SUBJECT TO CONSTANT AND FREQUENT
        FLUCTUATIONS, AND YOU MAY SUFFER COMPLETE LOSS OF THE FUNDS DEPOSITED IN
        YOUR ACCOUNT. YOU ARE SOLELY RESPONSIBLE FOR DETERMINING WHETHER THE USE
        OF ANY SERVICE IS SUITABLE FOR YOU IN LIGHT OF YOUR PERSONAL AND
        FINANCIAL CIRCUMSTANCES. COINWUSH BEARS NO RESPONSIBILITY OR LIABILITY
        FOR ANY LOSSES OR GAINS INCURRED IN CONNECTION WITH YOUR USE OF THE
        SERVICES. ALL TRADES ARE EXECUTED AUTOMATICALLY BASED ON THE PARAMETERS
        OF YOUR ORDER INSTRUCTIONS AND IN ACCORDANCE WITH OUR EXECUTION
        PROCEDURES. COINWUSH MERELY OFFERS A TECHNOLOGY PLATFORM FOR DERIVATIVE
        TRADING AND YOU ARE SOLELY AND ENTIRELY RESPONSIBLE FOR THE LEGAL,
        REGULATORY, AND TAX COMPLIANCE OF ALL TRANSACTIONS CARRIED OUT BY YOU
        USING THE SERVICES
      </p>
    </div>

    <!-- Sections -->
    <section>
      <h2>1. Definitions</h2>

      <p>
        For the purposes of these Terms, the following words and expressions
        shall have the meanings ascribed to them below, unless the context
        otherwise requires:
      </p>

      <ul>
        <li>
          <strong>"Account" or "User Account"</strong> – means the account
          created by a User on the Platform to access and use the Services.
        </li>

        <li>
          <strong>"Account Equity"</strong> – means the INR balance credited to
          your Account in our books and records, representing the total value of
          your funds in our custody, including margin used in existing
          positions, available margin, and unrealised profits or losses on open
          positions.
        </li>

        <li>
          <strong>"Applicable Laws"</strong> – means all laws, statutes, rules,
          regulations, orders, notifications, circulars, guidelines, policies,
          directions, judicial decisions, and governmental requirements
          applicable to the User or the Company in any relevant jurisdiction, as
          amended from time to time.
        </li>

        <li>
          <strong>"Auto-Deleveraging" or "ADL"</strong> – means the automatic
          reduction of winning positions in order to cover losses arising from
          insufficiently margined losing positions.
        </li>

        <li>
          <strong>"Breach Event"</strong> – means the occurrence, or reasonable
          likelihood of occurrence, of: (a) breach of Applicable Laws; (b)
          breach of these Terms or Policies; (c) suspicious or fraudulent
          activity; (d) submission of false KYC information; (e) failure to
          provide required documents; (f) compromising Platform integrity; or
          (g) regulatory complaints or investigations.
        </li>

        <li>
          <strong>"Company"</strong> – means Questalious Private Limited
          operating under the brand name "Coinwush".
        </li>

        <li>
          <strong>"Deposit"</strong> – means any transfer of INR made by a User
          from their Registered Bank Account to the Company's designated bank
          account for funding their Account.
        </li>

        <li>
          <strong>"Derivative Contract" or "Contract"</strong> – means any
          financial instrument offered on the Platform including Perpetual
          Futures, Options, and Margin positions derived from a Virtual Digital
          Asset.
        </li>

        <li>
          <strong>"Fiat Currency"</strong> – means Indian Rupees (INR) as
          defined under FEMA, 1999.
        </li>

        <li>
          <strong>"Force Majeure Event"</strong> – means any event beyond the
          reasonable control of Coinwush, including natural disasters, war,
          terrorism, government action, regulatory change, power outages,
          cyber-attacks, internet failures, blockchain changes, or similar
          causes.
        </li>

        <li>
          <strong>"Funding Fee"</strong> – means periodic payments associated
          with Perpetual Futures contracts, credited or debited depending on
          position type.
        </li>

        <li>
          <strong>"Futures Wallet"</strong> – means the designated ledger
          assigned to a User for Futures and Options trading.
        </li>

        <li>
          <strong>"GST"</strong> – means Goods and Services Tax under the
          Central Goods and Services Tax Act, 2017.
        </li>

        <li>
          <strong>"INR Balance" or "Fiat Wallet"</strong> – means the INR
          balance maintained by a User on the Platform.
        </li>

        <li>
          <strong>"ITA"</strong> – means the Income-tax Act, 1961, as amended.
        </li>

        <li>
          <strong>"KYC"</strong> – means Know Your Customer verification as
          required under Applicable Laws.
        </li>

        <li>
          <strong>"Leverage"</strong> – means the use of borrowed capital or
          margin to increase potential return or loss.
        </li>

        <li>
          <strong>"Linked Bank Account" or "Registered Bank Account"</strong> –
          means the verified bank account held by the User with a Scheduled
          Commercial Bank in India for Deposits and Withdrawals.
        </li>

        <li>
          <strong>"Liquidation"</strong> – means the automatic closure of open
          positions when margin falls below required maintenance level.
        </li>

        <li>
          <strong>"Margin"</strong> – means funds required as collateral to open
          and maintain a Derivative position.
        </li>

        <li>
          <strong>"Options"</strong> – means options contracts giving the holder
          the right, but not the obligation, to buy or sell an asset at a
          predetermined price.
        </li>

        <li>
          <strong>"Order"</strong> – means any instruction submitted through the
          Platform to open, modify, or close a Derivative position.
        </li>

        <li>
          <strong>"Perpetual Futures"</strong> – means derivative contracts
          without expiry, subject to margin and funding fees.
        </li>

        <li>
          <strong>"Platform"</strong> – means https://coinwush.com, associated
          mobile applications, APIs, software, and related tools operated by the
          Company.
        </li>

        <li>
          <strong>"Sanctions List"</strong> – means any restricted party lists
          issued by UN, RBI, FIU-IND, OFAC, Interpol, or similar authorities.
        </li>

        <li>
          <strong>"Security Incident"</strong> – means any suspected or
          confirmed compromise of a User's Account, device, or credentials.
        </li>

        <li>
          <strong>"Services"</strong> – means derivative trading, INR
          deposit/withdrawal services, account management, and related services.
        </li>

        <li>
          <strong>"Settlement"</strong> – means the calculation and credit/debit
          of profits or losses upon closing a Derivative Contract.
        </li>

        <li>
          <strong>"User", "you", or "your"</strong> – means any individual
          accessing or using the Platform.
        </li>

        <li>
          <strong>"Withdrawal"</strong> – means transfer of INR from a User's
          Account to their Registered Bank Account.
        </li>
      </ul>
    </section>

    <section>
      <h2>2. Nature Of Services And Platform</h2>
      <p>
        <strong>2.1</strong> Coinwush operates an online technology platform
        that enables Users to trade Derivative Contracts (Perpetual Futures,
        Options, and Margin products) linked to Virtual Digital Assets. All
        contracts are cash-settled exclusively in Indian Rupees (INR). Coinwush
        does not provide any Virtual Digital Asset custody, storage, holding, or
        transfer services. Users do not hold, receive, transfer, or own any
        Virtual Digital Assets through the Platform at any time.
      </p>
      <p>
        <strong>2.2</strong> Coinwush operates its own in-house order matching
        engine. All orders placed on the Platform are matched and executed
        through Coinwush's proprietary matching technology. Coinwush does not
        route orders to any third-party cryptocurrency exchange for execution.
      </p>
      <p>
        <strong>2.3</strong> Coinwush is a technology platform and facilitator.
        Nothing in these Terms or on the Platform shall be construed as
        constituting investment advice, financial advice, trading advice, tax
        advice, or any other form of professional advice. Coinwush does not
        recommend, endorse, or solicit the purchase or sale of any Derivative
        Contract or any investment strategy. All trading decisions are made
        solely by the User at their own risk.
      </p>
      <p>
        <strong>2.4</strong> Coinwush operates as a technology platform
        providing derivative trading infrastructure. Coinwush does not act as a
        bank, payment system operator, or custodian of Virtual Digital Assets.
        Users trade derivative contracts on the platform on a self-directed
        basis. The regulatory framework governing Virtual Digital Assets and
        related derivatives in India is evolving and subject to change.
      </p>
      <p>
        <strong>2.5</strong> The Platform is currently intended for use by
        residents of India and may not be available in certain jurisdictions
        where such services are restricted under applicable laws.
      </p>
      <p>
        <strong>2.6</strong> Coinwush reserves the right to modify, suspend,
        discontinue, or restrict any Service or feature on the Platform at any
        time, with or without prior notice, at its sole discretion. The Company
        shall not be liable for any losses resulting from such modifications,
        suspensions, or discontinuations.
      </p>
    </section>

    <section>
      <h2>3. Eligibility and User Representations</h2>

      <p>
        <strong>3.1</strong> To be eligible to register for and use the Platform
        and Services, you must satisfy all of the following conditions at all
        times:
      </p>

      <ol type="a">
        <li>
          You are an individual natural person of at least 18 years of age and
          are legally competent to enter into a binding contract under the
          Indian Contract Act, 1872;
        </li>

        <li>
          You are an Indian citizen and a person resident in India as defined
          under the Citizenship Act, 1955 and the Foreign Exchange Management
          Act, 1999;
        </li>

        <li>
          You are physically present in India while accessing and using the
          Platform and Services;
        </li>

        <li>
          You have not been previously suspended or removed from the Platform or
          any other Coinwush service;
        </li>

        <li>
          You are not included in any Sanctions List and are not subject to any
          adverse media report or investigation;
        </li>

        <li>
          You are not currently under investigation, inquiry, or audit by any
          government authority in relation to any offence involving fraud, money
          laundering, bribery, corruption, or dishonesty;
        </li>

        <li>
          You have not been declared insolvent or bankrupt, nor has any petition
          been filed by or against you for such purposes;
        </li>

        <li>
          Your use of the Platform does not and will not violate any Applicable
          Laws;
        </li>

        <li>
          You are not a citizen or resident of any country or territory on any
          Sanctions List or where use of the Platform would be prohibited or
          restricted under Applicable Laws.
        </li>
      </ol>

      <p>
        <strong>3.2</strong> By registering for a User Account, you represent,
        warrant, and undertake on an ongoing basis that:
      </p>

      <ol type="a">
        <li>
          All information provided by you to Coinwush is true, accurate,
          current, and complete, and you will promptly notify us of any changes;
        </li>

        <li>
          You are acting on your own behalf and not as an agent, nominee, or
          representative of any third party;
        </li>

        <li>
          You have full knowledge and disclosure of the current regulatory
          status with respect to Virtual Digital Assets and derivative trading
          in India and the risks involved;
        </li>

        <li>
          The funds deposited by you in your Account originate from lawful and
          legitimate sources and are not derived from any illegal activity;
        </li>

        <li>
          Your Registered Bank Account is held in your own name and you have
          full control over it;
        </li>

        <li>
          You have read and understood the Risk Disclosure set out in these
          Terms and in the Platform documentation;
        </li>

        <li>
          You have the financial resources, knowledge, and risk tolerance
          appropriate for derivative trading.
        </li>
      </ol>

      <p>
        <strong>3.3</strong> If you do not meet or cease to meet any of the
        above eligibility criteria, you must immediately stop using the Platform
        and Services and notify us at
        <a href="mailto:support@coinwush.com">support&#64;coinwush.com</a>. We
        reserve the right to suspend or terminate your Account if you do not
        satisfy the eligibility criteria at any time.
      </p>
    </section>

    <section>
      <h2>4. Account Registration and Management</h2>

      <p>
        <strong>4.1 Account Creation:</strong>
        To access the Services, you must create a User Account on the Platform
        by providing a valid email address, mobile number, and such other
        information as may be required by us from time to time. You must
        complete the identity verification and KYC process as stipulated in our
        KYC Policy before you can access trading features or make Deposits or
        Withdrawals.
      </p>

      <p>
        <strong>4.2 KYC Verification:</strong>
        As part of the account activation process, you will be required to
        submit identity documents including, but not limited to, your Aadhaar
        number (on a voluntary basis or as offline verification), PAN card, and
        details of your Registered Bank Account. We reserve the right to request
        additional documents or information at any time for identity
        verification, compliance, or regulatory purposes. We may use third-party
        service providers to conduct KYC and identity verification processes.
      </p>

      <p>
        <strong>4.3 Single Account:</strong>
        Each User is permitted to maintain only one User Account on the
        Platform. Creation of multiple accounts by the same individual is
        strictly prohibited and may result in termination of all such accounts
        and block, freeze, or restrict access to your Account balance in
        accordance with Applicable Laws.
      </p>

      <p>
        <strong>4.4 Account Security:</strong>
        You are solely and entirely responsible for maintaining the
        confidentiality and security of your Account credentials, including your
        password, OTP, MPIN, and any two-factor authentication details. You
        agree to:
      </p>

      <ol type="a">
        <li>use a strong and unique password;</li>
        <li>enable two-factor authentication;</li>
        <li>not share your credentials with any third party;</li>
        <li>log out of your Account after each session; and</li>
        <li>
          immediately notify us at
          <a href="mailto:support@coinwush.com">support&#64;coinwush.com</a>
          upon becoming aware of any unauthorized access to or use of your
          Account.
        </li>
      </ol>

      <p>
        <strong>4.5 Account Responsibility:</strong>
        All activities, orders, instructions, and transactions initiated from
        your Account are deemed to be authorized by you. Coinwush shall not be
        liable for any losses arising from unauthorized use of your Account due
        to your failure to maintain adequate security measures. We are not
        responsible for any unauthorized transactions once they have been
        executed.
      </p>

      <p>
        <strong>4.6 Account Updates:</strong>
        You agree to promptly update your Account information in the event of
        any change, including changes to your contact details, bank account
        details, or KYC documents. Failure to update such information may result
        in suspension or termination of your Account.
      </p>

      <p>
        <strong>4.7 Inactive Accounts:</strong>
        Coinwush reserves the right to designate a User Account as dormant if
        there has been no login or trading activity for a continuous period of
        twelve (12) months or more. Prior to such designation, the Company shall
        make reasonable efforts to notify the User at their registered email
        address or mobile number. If an Account remains inactive for a period of
        five (5) years and the User has not responded to notifications, we
        reserve the right to deal with the Account balance in accordance with
        Applicable Laws, including transfer to an investor protection fund.
      </p>

      <p>
        <strong>4.8 Nominee Facility:</strong>
        We encourage Users to designate a nominee for their Account through the
        Platform. In the event of your demise, your nominee may apply for
        transmission of your Account balance by submitting appropriate
        documentation as required by our internal policies, including proof of
        death, fresh KYC of the nominee, and an indemnity undertaking. Coinwush
        shall, upon satisfactory verification of documentation in its sole
        discretion, transfer the Account balance to the nominee's account. If no
        nominee has been designated, the legal beneficiary may apply with
        requisite documentation, and Coinwush shall act in accordance with
        Applicable Laws. Coinwush shall not be liable for any fraudulent or
        erroneous documentation submitted by third parties in connection with
        such claims.
      </p>

      <p>
        <strong>4.9 Referral Program:</strong>
        Coinwush may, at its sole discretion, operate a referral program from
        time to time, the terms of which shall be published on the Platform. You
        confirm that any referrals you make to Coinwush are made in your
        individual personal capacity and not in the course of any business or
        profession, unless you have entered into a separate written agreement
        with Coinwush permitting such referrals. If you are making referrals in
        the course of a business or profession without such an agreement,
        Coinwush reserves the right to deduct additional withholding taxes as
        required under Applicable Laws.
      </p>
    </section>

    <section>
      <h2>5. INR Deposit and Withdrawal Services</h2>

      <p>
        <strong>5.1 Deposit Process:</strong>
        To fund your Account and commence trading, you must transfer INR from
        your Registered Bank Account to Coinwush's designated bank account via
        UPI, IMPS, NEFT, or RTGS only. Deposits from any bank account other than
        your Registered Bank Account will not be accepted. Any amounts
        transferred from a non-registered bank account will be refunded to the
        source account within seven (7) working days, minus any applicable
        processing charges, and Coinwush shall not be responsible for any delays
        in such refund.
      </p>

      <p>
        <strong>5.2 Credit of Deposits:</strong>
        Upon receipt and verification of your Deposit, your Account Equity will
        be updated to reflect the deposited amount, net of any applicable fees
        and charges as disclosed on the Platform. Coinwush shall endeavor to
        credit Deposits within the timelines specified on the Platform, but does
        not guarantee immediate credit and shall not be liable for delays caused
        by banking channels, technical issues, or factors beyond its control.
      </p>

      <p>
        <strong>5.3 Deposit Conditions:</strong>
        By making a Deposit, you represent and warrant that:
      </p>

      <ol type="a">
        <li>
          you are the legal and beneficial owner of the funds being deposited;
        </li>
        <li>
          the funds are not derived from or associated with any illegal
          activity, money laundering, terrorist financing, or any violation of
          Applicable Laws; and
        </li>
        <li>
          the transfer does not constitute a breach of any Applicable Laws
          including foreign exchange regulations.
        </li>
      </ol>

      <p>
        <strong>5.4 Withdrawal Process:</strong>
        To withdraw INR from your Account, you must submit a withdrawal request
        through the Platform. Withdrawals will be processed exclusively to your
        Registered Bank Account. Coinwush will not process withdrawals to any
        third-party bank account under any circumstances.
      </p>

      <p>
        <strong>5.5 Withdrawal Conditions:</strong>
        Withdrawals are subject to:
      </p>

      <ol type="a">
        <li>
          there being no open positions or outstanding obligations in your
          Account;
        </li>
        <li>completion of any pending KYC or compliance requirements;</li>
        <li>
          deduction of applicable fees, taxes (including TDS under Section 194S
          of the ITA where applicable), and charges;
        </li>
        <li>
          there being no freeze, hold, or restriction on your Account; and
        </li>
        <li>
          compliance with Applicable Laws and Coinwush's internal policies.
        </li>
      </ol>

      <p>
        <strong>5.6 Withdrawal Timeline:</strong>
        Coinwush shall endeavor to process withdrawal requests within three (3)
        working days, subject to banking processing times and regulatory
        requirements. Larger withdrawals may take up to thirty (30) working
        days. Coinwush shall not be liable for delays caused by banking
        channels, government orders, or factors beyond its control. If
        Coinwush's bank account is frozen, injuncted, or made inaccessible by
        order of the Reserve Bank of India, a court, or any other regulatory
        authority, withdrawal processing shall be suspended until such
        restriction is lifted, and Coinwush shall not be liable for any losses
        arising therefrom.
      </p>

      <p>
        <strong>5.7 Deposit and Withdrawal Limits:</strong>
        Coinwush may impose minimum and maximum limits on Deposits and
        Withdrawals, which may vary based on your KYC verification level,
        account history, and other factors, and may be changed from time to time
        at Coinwush's discretion.
      </p>

      <p>
        <strong>5.8 Funds in Custody:</strong>
        Coinwush maintains internal ledger balances representing user funds used
        for trading activities on the Platform solely for the purpose of
        facilitating trading services. Your INR balance is not a deposit under
        the Companies Act, 2013 and does not earn any interest. Coinwush shall
        not use user funds for its own operational expenses or treasury
        purposes.
      </p>

      <p>
        <strong>5.9 Refund Policy:</strong>
        Once a trade has been executed on the Platform, all transactions are
        final, irreversible, and non-refundable. Refunds of Deposited funds
        (i.e., untraded balances) may be requested through the Platform subject
        to completion of applicable compliance and verification procedures.
      </p>
    </section>

    <section>
      <h2>6. DERIVATIVE TRADING SERVICES</h2>

      <p><strong>6.1 General Trading Terms</strong></p>

      <ol type="a">
        <li>
          Coinwush offers the following Derivative Contracts on the Platform:
          (i) Perpetual Futures contracts; (ii) Options contracts; and (iii)
          Margin positions. All contracts are cash-settled in INR only. No
          delivery of any Virtual Digital Asset shall be made at any time.
        </li>

        <li>
          All orders placed on the Platform are executed through Coinwush's
          in-house matching engine. Coinwush does not route orders to any
          external exchange or third-party platform.
        </li>

        <li>
          All orders are subject to availability of counterparties, sufficient
          margin, trading limits, and such other conditions as may be specified
          by Coinwush from time to time.
        </li>

        <li>
          Orders are only confirmed upon acknowledgment by Coinwush's systems.
          An order that does not reach Coinwush's backend systems due to
          connectivity issues, technical failures, or any other reason shall not
          be treated as received or accepted. Coinwush is not responsible for
          instructions that fail to reach its systems.
        </li>

        <li>
          In case of market orders, the execution price will be the price
          prevailing at the time of execution, which may differ from the price
          at the time of order placement. Coinwush is not liable for any such
          price differences.
        </li>

        <li>
          All executed orders are final, irreversible, non-refundable, and
          non-cancellable. Once a transaction is initiated and executed by you,
          it is absolute and unconditional. You cannot seek or claim a refund or
          reversal for any reason whatsoever, nor can it be cancelled or
          reversed upon your or any third party's request.
        </li>

        <li>
          Coinwush reserves the right, at its sole discretion, to cancel or
          correct any order that, due to a technical glitch, malfunction, or
          system error, did not reflect the fair market value of the applicable
          contract at the time of execution.
        </li>

        <li>
          Coinwush reserves the right to impose trading limits, position limits,
          leverage limits, and other risk controls at any time, with or without
          prior notice, and you may be prevented from placing orders or
          maintaining positions that breach such limits.
        </li>

        <li>
          Coinwush reserves the right to list or delist any Derivative Contract,
          modify contract specifications, or introduce new products at its sole
          discretion and without prior notice.
        </li>
      </ol>

      <p><strong>6.2 Perpetual Futures</strong></p>

      <ol type="a">
        <li>
          Perpetual Futures are derivative contracts that do not have an expiry
          date and can be held indefinitely, subject to the maintenance of
          adequate Margin and the periodic payment of Funding Fees.
        </li>

        <li>
          Funding Fees are periodic payments between holders of long and short
          positions, designed to keep the perpetual contract price aligned with
          the underlying spot price. Funding Fees may be positive or negative
          and will be credited to or debited from your Account at the intervals
          specified on the Platform.
        </li>

        <li>
          Users must maintain the required Margin in their Futures Wallet at all
          times. If your margin falls below the maintenance margin level, your
          position may be subject to Liquidation.
        </li>

        <li>
          Coinwush may, but is not obligated to, issue margin calls to Users.
          You are solely responsible for monitoring your positions and Margin
          levels at all times.
        </li>

        <li>
          Upon Liquidation, you may lose your entire Margin for the liquidated
          position, and a Liquidation Fee will be charged as per the fee
          schedule on the Platform.
        </li>

        <li>
          Coinwush reserves the right to suspend Perpetual Futures trading,
          modify contract parameters, or take any other action it deems
          necessary to maintain an orderly market, without prior notice and
          without liability.
        </li>
      </ol>

      <p><strong>6.3 Options</strong></p>

      <ol type="a">
        <li>
          Options contracts give the holder the right, but not the obligation,
          to buy or sell an underlying virtual digital asset at a predetermined
          price (strike price) on or before the expiry date.
        </li>

        <li>
          Options involve unlimited risk. Losses may exceed the initial margin
          blocked for a position, and your entire Options Wallet balance may be
          at risk. In the event of a negative balance, Coinwush reserves the
          right to recover any outstanding amounts from other balances in your
          Account.
        </li>

        <li>
          Users must maintain adequate Margin in their Options Wallet at all
          times. Upon insufficient Margin, orders may be rejected and positions
          may be subject to Liquidation.
        </li>

        <li>
          There is no guarantee of liquidity or of maintaining specific bid/ask
          spreads for any Options contracts. Market conditions may result in
          limited availability of counterparties, which could lead to delays in
          execution, partial fills, or rejection of orders. Coinwush shall not
          be responsible for any losses arising from limited or no liquidity.
        </li>

        <li>
          All Options contracts are subject to daily expiry terms as specified
          on the Platform. Coinwush reserves the right to list or delist any
          Options contract at any time without prior notice.
        </li>
      </ol>

      <p><strong>6.4 Margin Trading</strong></p>

      <ol type="a">
        <li>
          Margin trading allows Users to open leveraged positions by using
          borrowed capital, amplifying both potential gains and potential
          losses.
        </li>

        <li>
          Users must maintain the required Margin for all open positions.
          Failure to maintain the required Margin may result in Liquidation of
          positions and imposition of Liquidation Fees.
        </li>

        <li>
          Coinwush may, but is not obligated to, issue margin calls. You are
          solely responsible for monitoring your Margin levels and ensuring
          adequate funds are maintained at all times.
        </li>

        <li>
          By using Margin trading, you hereby create, in favour of Coinwush, a
          continuing first priority security interest, lien, and right of
          set-off against all of your right, title, and interest, present or
          future, in and over your Account balance, Futures Wallet, INR Balance,
          and all Assets held by Coinwush on your behalf (collectively,
          "Collateral"), to secure all payments and obligations due from you to
          Coinwush. You represent and warrant that the Collateral is and shall
          remain free and clear of all prior liens, claims, and encumbrances.
          Coinwush shall be entitled to invoke this security interest and
          appropriate the Collateral to the extent of any amounts due from you.
        </li>
      </ol>

      <p><strong>6.5 Auto-Deleveraging (ADL)</strong></p>

      <ol type="a">
        <li>
          In certain circumstances where a User's position is Liquidated but
          there are insufficient funds in the insurance fund to cover the
          losses, Coinwush may employ Auto-Deleveraging (ADL), which involves
          the automatic reduction of winning positions of other Users to offset
          the losses of the liquidated position.
        </li>

        <li>
          ADL may occur without prior notice. Users whose positions are
          auto-deleveraged will receive a notification after the event. Coinwush
          shall not be liable to any User for losses resulting from ADL.
        </li>

        <li>
          The priority of ADL is determined by the profitability and leverage of
          open positions, as specified in Coinwush's Exchange Rules published on
          the Platform.
        </li>

        <li>
          Users acknowledge that ADL is an inherent risk of derivative trading
          on leveraged platforms and by using the Services, expressly assume
          this risk.
        </li>
      </ol>
    </section>

    <section>
      <h2>7. FEES AND TAXES</h2>

      <p>
        <strong>7.1 Fee Schedule:</strong>
        Coinwush charges fees for use of the Services as set out in the Fee
        Schedule published on the Platform at
        <a href="https://coinwush.com/" target="_blank">https://coinwush.com/</a
        >. The Fee Schedule may be amended by Coinwush from time to time, and
        any changes shall be effective immediately upon posting on the Platform.
        By placing an Order, you authorize Coinwush to deduct applicable fees
        directly from your Account Equity.
      </p>

      <p>
        <strong>7.2 Trading Fees:</strong>
        Trading fees are charged on each executed Order as a percentage of the
        notional value of the contract, as specified in the Fee Schedule. Fees
        may vary based on your trading volume, account tier, and other factors
        determined by Coinwush.
      </p>

      <p>
        <strong>7.3 Funding Fees:</strong>
        Funding Fees for Perpetual Futures contracts will be periodically
        credited to or debited from your Account as described in Clause 6.2(b).
        Funding Fee rates are determined by market conditions and are published
        on the Platform.
      </p>

      <p>
        <strong>7.4 Liquidation Fees:</strong>
        A Liquidation Fee is charged upon the forced closure of any position due
        to insufficient Margin, as specified in the Fee Schedule.
      </p>

      <p>
        <strong>7.5 Deposit and Withdrawal Fees:</strong>
        Deposits and withdrawals of INR may be subject to processing fees as
        specified on the Platform from time to time. You are also responsible
        for any charges levied by your bank for NEFT, RTGS, IMPS, or UPI
        transactions.
      </p>

      <p>
        <strong>7.6 GST:</strong>
        All fees, commissions, and other charges of Coinwush are exclusive of
        applicable GST, which shall be charged separately and borne by you.
      </p>

      <p>
        <strong>7.7 Tax Deduction at Source (TDS):</strong>
        Coinwush, acting as an exchange/broker for spot market transactions,
        shall deduct and deposit applicable TDS under Section 194S of the ITA
        within the prescribed due dates in accordance with CBDT Circular No. 13
        of 2022. For all derivative transactions, Coinwush operates on a
        principal-to-principal basis, and TDS obligations, if any, shall be
        governed by Applicable Laws as clarified by the CBDT from time to time.
      </p>

      <p>
        <strong>7.8 User Tax Responsibility:</strong>
        You are solely responsible for determining, reporting, and paying all
        taxes applicable to your trading activities on the Platform, including
        income tax, GST, and any other taxes under Applicable Laws. Coinwush is
        not responsible for determining your individual tax liability or for
        collecting, reporting, or remitting taxes on your behalf, except as
        required under Applicable Laws. You are advised to consult a qualified
        tax advisor for guidance on your tax obligations.
      </p>

      <p>
        <strong>7.9 Reporting Irregularities:</strong>
        You are required to report any discrepancies or irregularities in your
        transactions to us in writing at
        <a href="mailto:support@coinwush.com">support&#64;coinwush.com</a>
        within fifteen (15) days of the relevant transaction date. Failure to
        report within this period will be deemed as your acceptance of the
        transaction as accurate and correct. All transaction records maintained
        by Coinwush in electronic form shall be deemed conclusive evidence of
        such transactions in the event of any dispute.
      </p>
    </section>

    <section>
      <h2>8. PROHIBITED ACTIVITIES</h2>

      <p>
        <strong>8.1 General Prohibition:</strong>
        You agree to use the Platform and Services only for lawful purposes and
        in compliance with Applicable Laws and these Terms. You shall not use
        the Platform for any purpose that is illegal, unlawful, fraudulent,
        abusive, or harmful.
      </p>

      <p>
        <strong
          >8.2 Without limiting the generality of the above, you agree that you
          shall not, directly or indirectly:</strong
        >
      </p>

      <ol type="a">
        <li>Violate these Terms, the Policies, or any Applicable Laws;</li>

        <li>
          Provide false, misleading, or inaccurate information, including KYC
          information, or impersonate any other person;
        </li>

        <li>
          Engage in, facilitate, or attempt to engage in any form of market
          manipulation, including but not limited to wash trading, spoofing,
          layering, front-running, pump-and-dump schemes, or any other deceptive
          or abusive trading practices;
        </li>

        <li>
          Use the Platform for money laundering, terrorist financing, fraud, or
          any other financial crime;
        </li>

        <li>
          Deposit or use funds that are derived from or associated with any
          illegal activity;
        </li>

        <li>
          Access or attempt to access any other User's Account without
          authorization;
        </li>

        <li>
          Use bots, automated scripts, scrapers, or any other automated tools to
          access or use the Platform without Coinwush's prior written consent;
        </li>

        <li>
          Reverse engineer, decompile, disassemble, or otherwise attempt to
          discover the source code of the Platform;
        </li>

        <li>
          Introduce or transmit any viruses, malware, ransomware, Trojan horses,
          spyware, or any other malicious or harmful code;
        </li>

        <li>
          Circumvent or attempt to bypass any security feature, access control,
          trading limit, position limit, or other restriction implemented by
          Coinwush;
        </li>

        <li>
          Use VPNs, proxies, TOR, or other anonymizing technologies to mask your
          identity or location for the purpose of evading detection or violating
          these Terms;
        </li>

        <li>
          Use multiple accounts or devices to gain an unfair advantage or
          circumvent any restrictions;
        </li>

        <li>
          Exploit any technical glitch, malfunction, or system vulnerability for
          personal gain;
        </li>

        <li>
          Use the Platform to engage in any activity that damages or impairs the
          functioning or reputation of Coinwush or the Platform;
        </li>

        <li>
          Collect personal information of other Users without authorization;
        </li>

        <li>
          Use the Platform to promote, solicit, or engage in any activity not
          authorised by these Terms or Applicable Laws;
        </li>

        <li>
          Threaten, harass, or intimidate Coinwush, its employees, agents, or
          any other User;
        </li>

        <li>
          Infringe upon the intellectual property rights, privacy rights, or any
          other rights of Coinwush or any third party.
        </li>
      </ol>

      <p>
        <strong>8.3 Consequences of Prohibited Activities:</strong>
        In the event Coinwush determines that you have engaged in any prohibited
        activity, Coinwush reserves the right to, without prior notice:
      </p>

      <ol type="a">
        <li>suspend or terminate your Account;</li>

        <li>
          block, freeze, or restrict access to your Account balance in
          accordance with Applicable Laws;
        </li>

        <li>cancel pending orders and close open positions;</li>

        <li>
          report you to regulatory, law enforcement, or judicial authorities;
        </li>

        <li>take civil or criminal legal action against you; and</li>

        <li>take any other action Coinwush deems appropriate.</li>
      </ol>
    </section>

    <section>
      <h2>9. ACCOUNT SUSPENSION, RESTRICTION, AND TERMINATION</h2>

      <p>
        <strong>9.1 Coinwush's Right to Act:</strong>
        Coinwush reserves the right, at its sole discretion and without prior
        notice, to take any or all of the following actions if a Breach Event
        has occurred or is reasonably suspected, or if required by Applicable
        Laws or any governmental, regulatory, or judicial authority:
      </p>

      <ol type="a">
        <li>
          Suspend, restrict, or terminate your Account and access to the
          Platform or any Services;
        </li>
        <li>
          block, freeze, or restrict access to your Account balance in
          accordance with Applicable Laws;
        </li>
        <li>
          Cancel, reverse, delay, or refuse to execute any order, transaction,
          or withdrawal;
        </li>
        <li>Close, offset, or liquidate any open positions;</li>
        <li>
          Deduct any amounts owed by you to Coinwush from your Account balance;
        </li>
        <li>Investigate your Account and any related accounts;</li>
        <li>
          Disclose your information to any authority as required or requested
          under Applicable Laws;
        </li>
        <li>
          Take any other remedial or preventive action Coinwush deems necessary.
        </li>
      </ol>

      <p>
        <strong>9.2 Notice of Termination:</strong>
        For routine account closures, Coinwush shall provide fifteen (15) days'
        prior written notice by email. However, no prior notice shall be
        provided where:
      </p>

      <ol type="a">
        <li>
          providing notice would violate Applicable Laws or a court or
          regulatory order;
        </li>
        <li>
          immediate action is required to prevent fraud, harm, or a security
          breach;
        </li>
        <li>the suspension is required by a law enforcement agency; or</li>
        <li>the Account is subject to ongoing investigation.</li>
      </ol>

      <p>
        <strong>9.3 User-Initiated Account Closure:</strong>
        You may close your Account at any time by following the procedure on the
        Platform or by writing to
        <a href="mailto:support@coinwush.com">support&#64;coinwush.com</a>,
        provided that:
      </p>

      <ol type="a">
        <li>all open positions have been closed;</li>
        <li>all pending transactions have been completed;</li>
        <li>all outstanding fees and charges have been paid; and</li>
        <li>
          all remaining Account balance has been withdrawn to your Registered
          Bank Account.
        </li>
      </ol>

      <p>
        <strong>9.4 Post-Termination:</strong>
        Upon termination of your Account:
      </p>

      <ol type="a">
        <li>you will lose access to the Platform and all Services;</li>
        <li>pending orders may be cancelled;</li>
        <li>
          Coinwush may retain your personal data and Account information as
          required by Applicable Laws for compliance, audit, and legal purposes;
        </li>
        <li>
          your obligations under these Terms that are intended to survive
          termination shall continue in full force and effect; and
        </li>
        <li>
          you shall remain liable for all obligations incurred prior to
          termination.
        </li>
      </ol>

      <p>
        <strong>9.5 Dormant Accounts:</strong>
        Users shall be provided at least thirty (30) days' prior notice before
        their Account is designated as dormant, except where immediate
        suspension is required due to fraud or regulatory directive.
      </p>
    </section>

    <section>
      <h2>10. RISK DISCLOSURE</h2>

      <p>
        <strong>10.1 Market Risk:</strong>
        Derivative Contracts linked to Virtual Digital Assets are subject to
        extreme price volatility. The value of the underlying assets can
        increase or decrease rapidly and significantly, and you may lose your
        entire Account balance. Past performance is not indicative of future
        results. Coinwush makes no representation or guarantee regarding the
        future value of any underlying asset or the outcome of any trade.
        Virtual Digital Assets are not legal tender and are not issued or backed
        by any government or central bank.
      </p>

      <p>
        <strong>10.2 Leverage Risk:</strong>
        Leverage amplifies both potential gains and potential losses. Trading
        with leverage means that a small adverse movement in the price of the
        underlying asset can result in a loss significantly greater than your
        initial Margin. You may lose more than your deposited Margin in certain
        circumstances.
      </p>

      <p>
        <strong>10.3 Liquidity Risk:</strong>
        Markets for Virtual Digital Assets may at times be illiquid, which may
        make it impossible to execute orders at desired prices or times, or to
        close positions when required. Thinly traded markets may experience high
        volatility and wide bid-ask spreads.
      </p>

      <p>
        <strong>10.4 Technology Risk:</strong>
        The Platform and related technology are subject to the risks inherent in
        internet-based systems, including connectivity failures, software bugs,
        hardware malfunctions, and cyber-attacks. Trading may be interrupted or
        delayed due to technical issues, and Coinwush does not guarantee
        uninterrupted access to the Platform.
      </p>

      <p>
        <strong>10.5 Regulatory Risk:</strong>
        The regulatory framework governing Virtual Digital Assets and derivative
        contracts in India is evolving and subject to change. Future regulatory
        changes could adversely impact your ability to use the Platform, your
        open positions, or the value of your Account balance. Coinwush may be
        required to discontinue certain Services or modify its operations in
        response to regulatory developments.
      </p>

      <p>
        <strong>10.6 Funding Fee Risk:</strong>
        Funding Fees for Perpetual Futures contracts can be significant during
        periods of high market volatility or directional market bias.
        Accumulation of Funding Fees can materially impact the profitability of
        your positions.
      </p>

      <p>
        <strong>10.7 Auto-Deleveraging Risk:</strong>
        Your winning positions may be reduced through Auto-Deleveraging without
        prior notice if the insurance fund is insufficient to cover losses from
        liquidated positions. This is an inherent risk of leveraged derivative
        trading.
      </p>

      <p>
        <strong>10.8 Cyber Security Risk:</strong>
        The Platform may be subject to hacking, phishing, malware, distributed
        denial-of-service attacks, or other cyber threats. While Coinwush
        implements security measures, it cannot guarantee complete protection
        against all cyber threats.
      </p>

      <p>
        <strong>10.9 Counterparty Risk:</strong>
        As Coinwush uses its own matching engine, your trades are matched
        against other Users. There is a risk that counterparties may default on
        their obligations, which may affect your Account in extreme market
        conditions.
      </p>

      <p>
        <strong>10.10 Unforeseen Risks:</strong>
        There may be additional risks not identified in these Terms. You are
        responsible for conducting your own due diligence and for familiarising
        yourself with all potential risks before using the Platform.
      </p>
      <p>
        <strong>10.11 Financial Risk Warning:</strong>
        Cryptocurrency derivative trading involves significant financial risk
        and may not be suitable for all users. Users should carefully consider
        their financial circumstances before participating in such trading
        activities. Virtual Digital Assets are not legal tender and are not
        issued or backed by any government or central bank.
      </p>
      <p>
        <strong>10.12 Acknowledgment:</strong>
        By using the Platform, you acknowledge that you have read and understood
        this Risk Disclosure, that you have assessed your financial situation
        and risk tolerance and found them suitable for derivative trading, and
        that you voluntarily assume all risks associated with your use of the
        Services.
      </p>
    </section>

    <section>
      <h2>11. NO WARRANTIES</h2>

      <p>
        <strong>11.1</strong>
        The Platform and all Services are provided on an "as is" and "as
        available" basis, without any warranty of any kind, express or implied,
        including but not limited to warranties of merchantability, fitness for
        a particular purpose, title, non-infringement, accuracy, reliability,
        completeness, or uninterrupted availability.
      </p>

      <p>
        <strong>11.2</strong>
        Coinwush does not warrant that:
      </p>

      <ol type="a">
        <li>
          the Platform will be available at all times or without interruption;
        </li>
        <li>the Platform will be free from errors, bugs, or other defects;</li>
        <li>
          the information on the Platform will be accurate, complete, or
          current;
        </li>
        <li>
          the Platform will be free from viruses, malware, or other harmful
          components;
        </li>
        <li>the Platform will meet your requirements or expectations.</li>
      </ol>

      <p>
        <strong>11.3</strong>
        Any information, content, or data provided on the Platform is for
        informational purposes only and is not to be relied upon for trading
        decisions. Coinwush makes no representation or warranty regarding the
        accuracy or reliability of any price data, market information, or other
        content on the Platform.
      </p>

      <p>
        <strong>11.4</strong>
        Coinwush does not warrant the performance, reliability, security, or
        stability of any third-party service, banking channel, or payment system
        used in connection with the Services.
      </p>
    </section>

    <section>
      <h2>12. LIMITATION OF LIABILITY</h2>

      <p>
        <strong>12.1</strong>
        To the maximum extent permitted by Applicable Laws, Coinwush and its
        directors, officers, employees, agents, contractors, and representatives
        (collectively, "Associated Parties") shall not be liable to any User for
        any losses, damages, or costs of any kind arising out of or in
        connection with the use of the Platform or Services.
      </p>

      <p>
        <strong>12.2</strong>
        The aggregate liability of Coinwush to any User, whether in contract,
        tort (including negligence), breach of statutory duty, or otherwise,
        arising out of or in connection with these Terms or the Services, shall
        in no event exceed the total fees paid by such User to Coinwush during
        the six (6) months immediately preceding the date of the claim.
      </p>

      <p>
        <strong>12.3</strong>
        Coinwush and the Associated Parties shall not be liable for any
        indirect, incidental, special, punitive, consequential, or similar
        damages or losses, including but not limited to loss of profits, loss of
        data, loss of business opportunity, loss of goodwill, or any other
        economic or non-economic loss, arising out of or in connection with the
        Services or these Terms, even if Coinwush has been advised of the
        possibility of such damages.
      </p>

      <p>
        <strong>12.4</strong>
        Coinwush shall not be liable for any losses arising from:
      </p>

      <ol type="a">
        <li>your trading decisions or investment choices;</li>
        <li>market volatility or adverse price movements;</li>
        <li>technical failures, internet outages, or connectivity issues;</li>
        <li>
          unauthorized access to your Account due to your failure to maintain
          security;
        </li>
        <li>
          actions of third parties including banks and payment processors;
        </li>
        <li>regulatory changes or governmental actions;</li>
        <li>Force Majeure Events;</li>
        <li>ADL of your positions;</li>
        <li>Liquidation of your positions due to insufficient Margin;</li>
        <li>errors in order entry by you;</li>
        <li>delays in processing Deposits or Withdrawals; or</li>
        <li>any other cause beyond Coinwush's reasonable control.</li>
      </ol>

      <p>
        <strong>12.5</strong>
        The limitations of liability set out in this clause reflect the
        allocation of risk between the parties and are an essential basis of the
        bargain between Coinwush and you. The Platform and Services would not be
        provided without these limitations.
      </p>
    </section>

    <section>
      <h2>13. INDEMNIFICATION</h2>

      <p>
        <strong>13.1</strong>
        You agree to indemnify, defend, and hold harmless Coinwush and its
        Associated Parties from and against any and all claims, demands,
        proceedings, liabilities, losses, damages, costs, and expenses
        (including reasonable legal fees on a full indemnity basis) arising out
        of or in connection with:
      </p>

      <ol type="a">
        <li>Your use of the Platform or Services;</li>
        <li>Your breach of these Terms or any other applicable Policies;</li>
        <li>Your violation of any Applicable Laws;</li>
        <li>
          Your violation of the rights of any third party, including
          intellectual property rights and privacy rights;
        </li>
        <li>Any fraud, wilful misconduct, or negligence on your part;</li>
        <li>
          Any dispute or legal proceeding caused by your acts or omissions.
        </li>
      </ol>

      <p>
        <strong>13.2</strong>
        This indemnification obligation shall survive the termination or expiry
        of these Terms and your use of the Platform.
      </p>

      <p>
        <strong>13.3</strong>
        Coinwush reserves the right, at your expense, to assume the exclusive
        defense and control of any matter for which you are required to
        indemnify Coinwush. You agree to cooperate with Coinwush's defense of
        such claims and not to settle any such matter without Coinwush's prior
        written consent.
      </p>
    </section>

    <section>
      <h2>14. SECURITY INCIDENTS</h2>

      <p>
        <strong>14.1</strong>
        If you suspect that your Account, device, security credentials, or
        Registered Bank Account details have been compromised, or if you notice
        any unusual or unauthorized activity in your Account (a "Security
        Incident"), you must immediately notify Coinwush at
        <a href="mailto:support@coinwush.com">support&#64;coinwush.com</a>
        and provide accurate and up-to-date information throughout the duration
        of the incident.
      </p>

      <p>
        <strong>14.2</strong>
        To assist in resolving a Security Incident, Coinwush may request your
        cooperation, including providing relevant details and periodic updates.
        You are required to promptly comply with all such requests and take all
        reasonable steps to mitigate or manage the Security Incident.
      </p>

      <p>
        <strong>14.3</strong>
        Coinwush shall not be liable for any losses resulting from a Security
        Incident caused by factors not within its reasonable control, including
        your failure to maintain adequate security for your Account.
      </p>

      <p>
        <strong>14.4</strong>
        Coinwush will acknowledge reported Security Incidents within forty-eight
        (48) hours and endeavor to resolve them within thirty (30) days.
      </p>
    </section>

    <section>
      <h2>15. SUSPENSION OF SERVICES</h2>

      <p>
        <strong>15.1</strong>
        Coinwush reserves the right to suspend all or any part of the Platform
        or Services at any time, including for the following reasons:
      </p>

      <ol type="a">
        <li>scheduled or emergency maintenance;</li>
        <li>system upgrades;</li>
        <li>security concerns;</li>
        <li>a Breach Event or Security Incident;</li>
        <li>regulatory or legal requirements;</li>
        <li>Force Majeure Events;</li>
        <li>
          to protect the interests of Users or the integrity of the market; or
        </li>
        <li>any other reason at Coinwush's sole discretion.</li>
      </ol>

      <p>
        <strong>15.2</strong>
        Coinwush shall not be liable for any losses, damages, or costs arising
        from any suspension, interruption, or unavailability of the Platform or
        Services.
      </p>
    </section>

    <section>
      <h2>16. INTELLECTUAL PROPERTY RIGHTS</h2>

      <p>
        <strong>16.1</strong>
        All rights, title, and interest in and to the Platform, including
        without limitation all intellectual property rights (whether registered
        or unregistered), are and shall remain the exclusive property of
        Coinwush and its licensors. This includes the "Coinwush" name, logo,
        branding, user interfaces, software code, matching engine, algorithms,
        databases, and all other proprietary technology and materials.
      </p>

      <p>
        <strong>16.2</strong>
        Subject to your compliance with these Terms, Coinwush grants you a
        limited, personal, non-exclusive, non-transferable, non-sublicensable,
        revocable license to access and use the Platform solely for your
        personal, non-commercial use for the purpose of availing the Services.
        No other license or right is granted.
      </p>

      <p>
        <strong>16.3</strong>
        You shall not:
      </p>

      <ol type="a">
        <li>
          copy, reproduce, modify, adapt, create derivative works from,
          distribute, or publicly display any part of the Platform;
        </li>
        <li>
          reverse engineer, decompile, or disassemble any software forming part
          of the Platform;
        </li>
        <li>
          use any data mining, robots, scrapers, or similar tools on the
          Platform;
        </li>
        <li>
          remove, alter, or obscure any intellectual property notices on the
          Platform;
        </li>
        <li>
          use Coinwush's trademarks, logos, or brand elements without prior
          written consent.
        </li>
      </ol>

      <p>
        <strong>16.4</strong>
        Any feedback, ideas, or suggestions provided by you regarding the
        Platform or Services shall be owned exclusively by Coinwush, and you
        hereby irrevocably assign all intellectual property rights therein to
        Coinwush without any obligation to compensate you.
      </p>
    </section>

    <section>
      <h2>17. THIRD-PARTY SERVICES AND LINKS</h2>

      <p>
        <strong>17.1</strong>
        The Platform may contain links to or integrations with third-party
        websites, services, or resources. Coinwush does not control, endorse, or
        take responsibility for the content, availability, or practices of any
        third-party services. Your use of third-party services is at your own
        risk and is governed by the terms and conditions of the respective third
        party.
      </p>

      <p>
        <strong>17.2</strong>
        Coinwush shall not be liable for any losses or damages arising from your
        use of or reliance on any third-party service or content accessed
        through the Platform.
      </p>
    </section>

    <section>
      <h2>18. PRIVACY AND DATA PROTECTION</h2>

      <p>
        <strong>18.1</strong>
        Coinwush collects, processes, and stores your personal information in
        accordance with its Privacy Policy, available at
        <a href="https://coinwush.com/" target="_blank">https://coinwush.com/</a
        >, and in compliance with the Information Technology Act, 2000, the
        Information Technology (Reasonable Security Practices and Procedures and
        Sensitive Personal Data or Information) Rules, 2011, the Digital
        Personal Data Protection Act, 2023 (when effective), and other
        Applicable Laws.
      </p>

      <p>
        <strong>18.2</strong>
        By using the Platform, you consent to the collection, use, and
        processing of your personal information as described in the Privacy
        Policy. You also consent to Coinwush sharing your information with
        regulatory, law enforcement, or judicial authorities as required by
        Applicable Laws.
      </p>

      <p>
        <strong>18.3</strong>
        You are solely responsible for ensuring that your contact information,
        including your registered email address and mobile number, is accurate
        and kept up to date at all times. Communications sent to your registered
        email address or mobile number shall be deemed to have been duly
        delivered and received by you.
      </p>
    </section>

    <section>
      <h2>19. ELECTRONIC COMMUNICATIONS</h2>

      <p>
        <strong>19.1</strong>
        By using the Platform, you consent to receive all communications,
        agreements, notices, disclosures, and other information from Coinwush in
        electronic form, including by email, SMS, WhatsApp, push notifications,
        or posting on the Platform.
      </p>

      <p>
        <strong>19.2</strong>
        All electronic communications sent to your registered contact details
        shall be deemed received by you and shall constitute effective, valid,
        and binding notice for all legal, contractual, and regulatory purposes.
      </p>

      <p>
        <strong>19.3</strong>
        You are responsible for ensuring that your registered email address and
        mobile number are current and accurate. If communications are
        undeliverable due to incorrect or outdated contact details, Coinwush may
        suspend your access to the Platform until updated details are provided.
      </p>

      <p>
        <strong>19.4</strong>
        Notwithstanding any Do Not Disturb (DND) registration, you hereby grant
        explicit consent to Coinwush and its affiliates to contact you via
        calls, SMS, emails, and other modes of communication in connection with
        the Services.
      </p>
    </section>

    <section>
      <h2>20. GOVERNING LAW AND DISPUTE RESOLUTION</h2>

      <p>
        <strong>20.1 Governing Law:</strong>
        These Terms and any non-contractual obligations arising out of or in
        connection with them shall be governed by and construed in accordance
        with the laws of India, without regard to its conflict of laws
        principles.
      </p>

      <p>
        <strong>20.2 Amicable Resolution:</strong>
        In the event of any dispute, controversy, or claim arising out of or
        relating to these Terms or the Services, the parties shall first
        endeavor to resolve the matter amicably through good-faith negotiation
        within thirty (30) days of the dispute being raised in writing.
      </p>

      <!-- <p>
        <strong>20.3 Arbitration:</strong>
        If the dispute cannot be resolved by amicable negotiation within the
        period specified in Clause 20.2, it shall be referred to and finally
        resolved by arbitration in accordance with the Arbitration and
        Conciliation Act, 1996, as amended from time to time. The arbitral
        tribunal shall consist of a sole arbitrator appointed by mutual
        agreement of the parties. If the parties are unable to agree on a sole
        arbitrator, the tribunal shall consist of three arbitrators, with each
        party appointing one arbitrator and the two appointed arbitrators
        jointly appointing the third. The seat and venue of arbitration shall be
        Meerut, Uttar Pradesh, India. The language of arbitration shall be
        English. The arbitrator's award shall be final and binding on both
        parties and may be enforced by any court of competent jurisdiction.
      </p> -->
      <!-- 
      <p>
        <strong>20.4 Jurisdiction:</strong>
        Subject to the arbitration clause above, the courts located in Meerut,
        Uttar Pradesh, India shall have exclusive jurisdiction over any matter
        arising out of or in connection with these Terms or the Services.
      </p> -->

      <p>
        <strong>20.5 Confidentiality:</strong>
        All aspects of any dispute or arbitration proceedings, including the
        arbitrator's award, shall be kept strictly confidential by both parties,
        except where disclosure is required by Applicable Laws or is necessary
        for enforcement of an award.
      </p>

      <p>
        <strong>20.6 No Class Actions:</strong>
        All disputes shall be resolved individually. You waive any right to
        participate in a class action, consolidated proceeding, or
        representative action against Coinwush.
      </p>
    </section>

    <section>
      <h2>21. FORCE MAJEURE</h2>

      <p>
        <strong>21.1</strong>
        Coinwush shall not be liable for any delay or failure to perform any
        obligation under these Terms arising from a Force Majeure Event.
        Coinwush's obligations shall be deemed suspended for the duration of
        such event, and Coinwush reserves the right to delay, suspend, or cancel
        any affected Services or transactions without liability.
      </p>

      <p>
        <strong>21.2</strong>
        Coinwush shall, to the extent reasonably practicable, notify Users of
        the occurrence and expected duration of a Force Majeure Event through
        the Platform or by email.
      </p>
    </section>

    <section>
      <h2>22. MISCELLANEOUS</h2>

      <p>
        <strong>22.1 Entire Agreement:</strong>
        These Terms, together with the Privacy Policy and any other applicable
        Policies published on the Platform, constitute the entire and exclusive
        agreement between you and Coinwush with respect to your use of the
        Platform and Services, and supersede all prior or contemporaneous
        agreements, representations, warranties, and understandings.
      </p>

      <p>
        <strong>22.2 Amendment:</strong>
        Coinwush reserves the right to amend, modify, or replace these Terms at
        any time at its sole discretion. Material changes will be notified
        through a notice on the Platform home page or by email at least thirty
        (30) days in advance, except where immediate changes are required for
        security or legal compliance reasons. Your continued use of the Platform
        after the effective date of any amendment constitutes your acceptance of
        the revised Terms. If you do not agree with any amendment, you must
        immediately cease using the Platform and Services.
      </p>

      <p>
        <strong>22.3 Severability:</strong>
        If any provision of these Terms is held to be invalid, illegal, or
        unenforceable by a court of competent jurisdiction, such provision shall
        be modified to the minimum extent necessary to make it enforceable, and
        the remaining provisions shall continue in full force and effect.
      </p>

      <p>
        <strong>22.4 Waiver:</strong>
        No failure or delay by Coinwush in exercising any right, power, or
        remedy under these Terms shall operate as a waiver of such right, power,
        or remedy. No waiver shall be effective unless made in writing and
        signed by an authorised representative of Coinwush.
      </p>

      <p>
        <strong>22.5 Assignment:</strong>
        You may not assign or transfer any of your rights or obligations under
        these Terms without the prior written consent of Coinwush. Coinwush may
        freely assign or transfer its rights and obligations under these Terms
        without your consent, including in connection with a merger,
        acquisition, or sale of all or substantially all of its assets.
      </p>

      <p>
        <strong>22.6 No Agency:</strong>
        Nothing in these Terms shall be construed as creating any agency,
        partnership, joint venture, employment relationship, or franchise
        relationship between you and Coinwush.
      </p>

      <p>
        <strong>22.7 Headings:</strong>
        Section headings in these Terms are for convenience only and shall not
        affect the interpretation of any provision.
      </p>

      <p>
        <strong>22.8 Language:</strong>
        These Terms are drafted in the English language. In the event of any
        conflict between the English version and any translation, the English
        version shall prevail.
      </p>

      <p>
        <strong>22.9 Survival:</strong>
        The following provisions shall survive termination or expiry of these
        Terms: Risk Disclosure, Limitation of Liability, Indemnification,
        Intellectual Property Rights, Governing Law and Dispute Resolution, and
        any other provision which by its nature is intended to survive
        termination.
      </p>

      <p>
        <strong>22.10 Set-Off:</strong>
        In the event that any amounts are owed by you to Coinwush under these
        Terms or Applicable Laws, Coinwush reserves the right to deduct such
        amounts from your Account balance and/or withhold amounts from any
        transactions or Withdrawals.
      </p>

      <p>
        <strong>22.11 Remedies Cumulative:</strong>
        The rights and remedies of Coinwush under these Terms are cumulative and
        in addition to any other rights and remedies available under Applicable
        Laws, equity, or contract.
      </p>
    </section>

    <section>
      <h2>23. COMPLIANCE WITH APPLICABLE LAWS</h2>

      <p>
        <strong>23.1</strong>
        You are solely responsible for ensuring that your use of the Platform
        and Services complies with all Applicable Laws in all jurisdictions
        relevant to you, including but not limited to the Income-tax Act, 1961,
        the Prevention of Money Laundering Act, 2002, the Foreign Exchange
        Management Act, 1999, the Information Technology Act, 2000, and all
        rules, regulations, notifications, and circulars issued thereunder.
      </p>

      <p>
        <strong>23.2</strong>
        Coinwush reserves the right to take any action it deems necessary or
        appropriate to comply with Applicable Laws, including disclosing your
        information to governmental or regulatory authorities, blocking or
        freezing your Account, or refusing to process transactions.
      </p>

      <p>
        <strong>23.3</strong>
        You shall promptly execute and deliver any additional documents and take
        any further actions that may be necessary or appropriate to give effect
        to these Terms and comply with all Applicable Laws.
      </p>
    </section>

    <section>
      <h2>24. GRIEVANCE REDRESSAL</h2>

      <p>
        <strong>24.1 Grievance Officer:</strong>
        In accordance with the Information Technology Act, 2000 and the
        Information Technology (Intermediary Guidelines and Digital Media Ethics
        Code) Rules, 2021, Coinwush has designated the following Grievance
        Officer:
      </p>

      <p>
        Name: Rishabh Mittal<br />
        Designation: Grievance Officer<br />
        Email:
        <a href="mailto:compliance@coinwush.com">compliance&#64;coinwush.com</a
        ><br />
        Platform:
        <a href="https://coinwush.com/support" target="_blank"
          >https://coinwush.com/support</a
        >
      </p>

      <p>
        <strong>24.2</strong>
        Any User who has a grievance, complaint, or query regarding the Platform
        or Services may contact the Grievance Officer at the above details. The
        Grievance Officer shall acknowledge complaints within forty-eight (48)
        hours of receipt and endeavor to resolve them within thirty (30) days.
      </p>

      <p>
        <strong>24.3 Nodal Officer:</strong>
        For inquiries from law enforcement, regulatory, statutory, or judicial
        authorities, please contact:
      </p>

      <p>
        Email: <a href="mailto:legal@coinwush.com">legal&#64;coinwush.com</a>
      </p>

      <p>
        <strong>24.4 General Support:</strong>
        For general support queries, please contact:
      </p>

      <p>
        Email: <a href="mailto:support@coinwush.com">support&#64;coinwush.com</a
        ><br />
        Website:
        <a href="https://coinwush.com/support" target="_blank"
          >https://coinwush.com/support</a
        >
      </p>
    </section>

    <!-- Final Risk Warning -->
    <div class="highlight-box danger">
      <h3>Final Risk Warning</h3>
      <p>
        CRYPTO DERIVATIVE PRODUCTS ARE UNREGULATED AND CAN BE HIGHLY RISKY.
        THERE MAY BE NO REGULATORY RECOURSE FOR ANY LOSS FROM SUCH TRANSACTIONS.
        IN THE EVENT THAT APPLICABLE LAWS CHANGE (INCLUDING BY WAY OF JUDICIAL
        OR EXECUTIVE ORDER) AND RENDER DERIVATIVE TRADING LINKED TO VIRTUAL
        DIGITAL ASSETS TO BE INVALID OR ILLEGAL IN INDIA, THESE TERMS SHALL
        STAND AUTOMATICALLY TERMINATED WITH EFFECT FROM THE DATE OF SUCH
        INVALIDITY OR ILLEGALITY WITHOUT FURTHER NOTICE OR RECOURSE AVAILABLE TO
        THE USER. YOU REPRESENT AND DECLARE THAT YOU HAVE FULL KNOWLEDGE AND
        DISCLOSURE OF THE CURRENT GOVERNMENT AND REGULATORY STATUS WITH RESPECT
        TO VIRTUAL DIGITAL ASSETS IN INDIA AND THE RISKS INVOLVED IN DERIVATIVE
        TRADING. BY ACCESSING THE PLATFORM AND/OR SERVICES, YOU ARE DEEMED TO
        HAVE UNDERSTOOD, AGREED TO, AND ACCEPTED THE RISKS, LOSSES, AND COSTS
        ASSOCIATED THEREWITH, INCLUDING BUT NOT LIMITED TO TOTAL OR COMPLETE
        LOSS OF YOUR ACCOUNT BALANCE.
      </p>
    </div>

    <div class="acknowledgment-box">
      <p>
        <strong>
          BY ACCESSING, REGISTERING FOR, OR USING THE COINWUSH PLATFORM OR
          SERVICES, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO
          BE BOUND BY THESE TERMS AND CONDITIONS IN THEIR ENTIRETY.
        </strong>
      </p>
    </div>

    <!-- <div class="footer-note">
      <p>
        Questalious Private Limited | CIN: U63119UP2025PTC222413<br />
        155/101, Gali No. 7, Hari Nagar, Kankerkhera, Meerut – 250001, Uttar
        Pradesh, India<br />
        Website: https://coinwush.com | Support: support&#64;coinwush.com
      </p>
    </div> -->
  </div>
</div>
